import React from "react";
import { DRUG_MATRIX_CATEGORY_GUIDE } from "../lib/drugMatrix";

export default function DrugCategoryGuide({ compact = false }) {
  return (
    <section className={`pguh-drug-category-guide${compact ? " pguh-drug-category-guide--compact" : ""}`} aria-labelledby="drug-category-guide-title">
      <div className="pguh-drug-category-guide__heading">
        <span className="pguh-eyebrow">Category guide</span>
        <h2 id="drug-category-guide-title">What each category means</h2>
        <p>Use these definitions as a quick reference when browsing or adding medicines to the Drug Matrix.</p>
      </div>
      <div className="pguh-drug-category-guide__grid">
        {DRUG_MATRIX_CATEGORY_GUIDE.map((item) => (
          <article key={item.name} className="pguh-drug-category-guide__item">
            <h3>{item.name}</h3>
            <p>{item.description}</p>
          </article>
        ))}
      </div>
    </section>
  );
}
